// extracted by mini-css-extract-plugin
export default {"contactUs":"styles_contactUs__UBWqa","content":"styles_content__jaLLh","link":"styles_link__Asb4U"};